export default __webpack_public_path__ + "static/img/vogue_scene_animated_0429.ab4222f.jpg";